// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/marketing_consent/firstparty/v1/global_unsubscribe.proto

/* oxlint-disable */

/** Request message for globally unsubscribing a client from all marketing communications. */
export interface ApiGlobalUnsubscribeRequest {
}

/** Response message for a successful global unsubscribe (maps to HTTP 204 No Content). */
export interface ApiGlobalUnsubscribeResponse {
}

/** Custom application error codes for the GlobalUnsubscribe operation. */
export interface ApiGlobalUnsubscribeErrors {
}

/** Custom application error codes for 404 HTTP errors. */
export const ApiGlobalUnsubscribeErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - No or unknown application-specific error code was given; use the error's status field as guidance. */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /**
   * not_found - Client consent record was not found.
   */
  not_found: "not_found",
} as const;

export type ApiGlobalUnsubscribeErrorsNotFoundError =
  typeof ApiGlobalUnsubscribeErrorsNotFoundError[keyof typeof ApiGlobalUnsubscribeErrorsNotFoundError];

export namespace ApiGlobalUnsubscribeErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiGlobalUnsubscribeErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type not_found = typeof ApiGlobalUnsubscribeErrorsNotFoundError.not_found;
}

export function apiGlobalUnsubscribeErrorsNotFoundErrorFromJSON(object: any): ApiGlobalUnsubscribeErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiGlobalUnsubscribeErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "not_found":
      return ApiGlobalUnsubscribeErrorsNotFoundError.not_found;
    default:
      return ApiGlobalUnsubscribeErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiGlobalUnsubscribeErrorsNotFoundErrorToJSON(object: ApiGlobalUnsubscribeErrorsNotFoundError): string {
  switch (object) {
    case ApiGlobalUnsubscribeErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiGlobalUnsubscribeErrorsNotFoundError.not_found:
      return "not_found";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

export const ApiGlobalUnsubscribeRequest: MessageFns<ApiGlobalUnsubscribeRequest> = {
  fromJSON(_: any): ApiGlobalUnsubscribeRequest {
    return {};
  },

  toJSON(_: ApiGlobalUnsubscribeRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiGlobalUnsubscribeResponse: MessageFns<ApiGlobalUnsubscribeResponse> = {
  fromJSON(_: any): ApiGlobalUnsubscribeResponse {
    return {};
  },

  toJSON(_: ApiGlobalUnsubscribeResponse): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiGlobalUnsubscribeErrors: MessageFns<ApiGlobalUnsubscribeErrors> = {
  fromJSON(_: any): ApiGlobalUnsubscribeErrors {
    return {};
  },

  toJSON(_: ApiGlobalUnsubscribeErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
